const ROOT = 'NEW_SKILLS_APPLICATIONS_';

const actions = {
  LOAD_SKILL_APPLICATIONS_REQUEST: `${ROOT}LOAD_SKILL_APPLICATIONS_REQUEST`,
  LOAD_SKILL_APPLICATIONS_SUCCESS: `${ROOT}LOAD_SKILL_APPLICATIONS_SUCCESS`,
  LOAD_SKILL_APPLICATIONS_ERROR: `${ROOT}LOAD_SKILL_APPLICATIONS_ERROR`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  PROCESS_ACTION_SUCCESS: `${ROOT}PROCESS_ACTION_SUCCESS`,
  PROCESS_ACTION_ERROR: `${ROOT}PROCESS_ACTION_ERROR`,
} as const;

export default actions;
